module.exports = __webpack_public_path__ + "img/1.1f484ad1.jpg";